<template>
  <div
    v-if="isDebugEnabled"
    class="account-data-debug p-3 bg-light border rounded"
  >
    <pre>{{ prettyAccountData }}</pre>
    <!-- Force Reset Button -->
    <button class="btn btn-warning w-100 mt-2" @click="handleResetAccountData">
      Force Reset Account Data
    </button>
  </div>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/composables/account/useAccountStore";
import { useGlobalHandlers } from "@/composables/useGlobalHandlers";
import { computed } from "vue";
import type { Account } from "../../types";
import { useRoute } from "vue-router";

const props = defineProps<{
  accountData: Account;
}>();

const emit = defineEmits<{
  resetAccountData: [];
}>();

const route = useRoute();
const accountStore = useAccountStore();
const { globalErrorHandler } = useGlobalHandlers();

const prettyAccountData = computed(() =>
  JSON.stringify(props.accountData, null, 2)
);
const isDebugEnabled = computed(() => {
  return route.query.debug === "true";
});

const resetAccountData = () => {
  emit("resetAccountData");
};
const handleResetAccountData = async () => {
  // Retain id and email, reset other fields
  const updatedAccountData = {
    ...props.accountData,
    name: "",
    registry_code: "",
    phone_number: "",
    has_registered: false,
  };
  try {
    await accountStore.postAccountData(
      "/api/onboarding/signup",
      updatedAccountData
    );
  } catch (error: unknown) {
    globalErrorHandler(error);
  }
};

// setup() returned resetAccountData, so it was reachable through a template ref;
// <script setup> closes the instance, so keep it reachable explicitly.
defineExpose({ resetAccountData });
</script>

<style lang="scss" scoped>
.account-data-debug {
  margin-top: 1rem;
  margin-bottom: 1rem;
  pre {
    font-family: monospace;
    white-space: pre-wrap;
    text-align: left; /* Align text to the left */
    tab-size: 4; /* Indentation size */
    max-height: auto; /* Dynamic height based on content */
    overflow-y: auto;
  }
  button {
    margin-top: 1rem;
  }
}
</style>
